import React from 'react'
import { IconButton } from '@paintscout/ui'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import type moment from 'moment'
import { formatWeekRange, weekOffsetLabel } from './dateUtils'
import type { usePainterScheduleLayoutStyles } from './usePainterScheduleLayoutStyles'

interface WeekNavigatorProps {
  weekStart: moment.Moment
  weekOffset: number
  onPrevWeek: () => void
  onNextWeek: () => void
  disabled?: boolean
  classes: ReturnType<typeof usePainterScheduleLayoutStyles>
}

export default function WeekNavigator({
  weekStart,
  weekOffset,
  onPrevWeek,
  onNextWeek,
  disabled,
  classes
}: WeekNavigatorProps) {
  return (
    <div className={classes.weekNavSection}>
      <div className={classes.weekNavRow}>
        <IconButton
          className={classes.navArrow}
          onClick={onPrevWeek}
          disabled={disabled || weekOffset <= -1}
          aria-label="previous week"
          size="small"
        >
          <ChevronLeftIcon />
        </IconButton>
        <div className={classes.weekNavCenter}>
          <span className={classes.weekRangeText}>{formatWeekRange(weekStart)}</span>
          <span className={classes.weekBadge}>
            <span className={classes.weekBadgeText}>{weekOffsetLabel(weekOffset)}</span>
          </span>
        </div>
        <IconButton
          className={classes.navArrow}
          onClick={onNextWeek}
          disabled={disabled || weekOffset >= 1}
          aria-label="next week"
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
    </div>
  )
}
